const STORAGE_PREFIX = 'admin_search_state:';

export const buildSearchStorageKey = (pageKey) => `${STORAGE_PREFIX}${pageKey}`;

export const readPersistedSearchState = (
    storageKey,
    emptyFilters,
    {
        defaultPage = 1,
        defaultItemsPerPage = 10,
        withCompanyPartnerSearch = false,
    } = {}
) => {
    try {
        const raw = sessionStorage.getItem(storageKey);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const result = {
            filters: { ...emptyFilters, ...(parsed.filters || {}) },
            appliedFilters: { ...emptyFilters, ...(parsed.appliedFilters || {}) },
            currentPage: Number(parsed.currentPage) > 0 ? Number(parsed.currentPage) : defaultPage,
            itemsPerPage: Number(parsed.itemsPerPage) > 0 ? Number(parsed.itemsPerPage) : defaultItemsPerPage,
        };
        if (withCompanyPartnerSearch) {
            result.companyPartnerSearch = String(parsed.companyPartnerSearch || '');
        }
        return result;
    } catch {
        return null;
    }
};

export const savePersistedSearchState = (storageKey, state) => {
    try {
        sessionStorage.setItem(storageKey, JSON.stringify(state));
    } catch {
        // ignore quota / private mode
    }
};

export const clearPersistedSearchState = (storageKey) => {
    try {
        sessionStorage.removeItem(storageKey);
    } catch {
        // ignore
    }
};

/** Lecture d'un état libre (pages multi-onglets, champs supplémentaires). */
export const readPersistedPageState = (storageKey) => {
    try {
        const raw = sessionStorage.getItem(storageKey);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const savePersistedPageState = (storageKey, state) => {
    savePersistedSearchState(storageKey, state);
};

export const clearPersistedPageState = (storageKey) => {
    clearPersistedSearchState(storageKey);
};
